/** @jsxImportSource @emotion/react */
import * as s from './style'
import React, { useEffect, useState } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
const YearSelector = ({ selectedYear, setSelectedYear, selectedCategory, displayAll, selectedCategoryIndex }) => {
    const [ yearArray, setYearArray ] = useState();

    useEffect(() => {
        if(selectedCategory) {
            initYearArray();
        }
    }, [selectedCategory?.categoryCd, selectedCategoryIndex])

    useEffect(() => {
        if(yearArray) {
            const newSelectedYear = yearArray.find(year => year.selected).value;
            setSelectedYear(newSelectedYear);
        }
    }, [yearArray])

    const initYearArray = () => {
        const { start_yyyy, end_yyyy } = selectedCategory;
        const newYearArray = Array.from({ length: parseInt(end_yyyy) - parseInt(start_yyyy) + 1},
            (_, index) => ({
                 index: index,
                 value: parseInt(start_yyyy) + index,
                 display: false,
                 selected: false
                }));
        
        const yearArrayIndexs = newYearArray.map(year => year.index); 
        const lastIndex = Math.max(...yearArrayIndexs);
        
        if(selectedCategory.year !== undefined) {
            newYearArray.find((year) => year.value === selectedCategory.year).selected = true;
            const selectedYear = newYearArray.find((year) => year.selected === true);
            const resultArray = setYearDisplay(newYearArray, selectedYear);
            setYearArray(resultArray);
        } else {
            newYearArray[lastIndex].selected = true;
            if(displayAll) {
                newYearArray.forEach((year) => {
                    year.display = true;
                })
            } else {
                newYearArray.forEach((year) => {
                    if(year.index >= lastIndex - 3) {
                        year.display = true;
                    }
                })
            }
            setYearArray(newYearArray);
        }
        
            
    }

    const onClickYearHandle = async (newYear) => {
        const newyearArray = yearArray.map((year) => ({
            ...year,
            selected: year.index === newYear.index,
        }));
    
        setYearArray(newyearArray);
    }  
    
    const onClickArrowHandle = (operator, active) => {
        if(active) {
            const displayedyearArray = yearArray.filter(year => year.display);
            const indexArray = displayedyearArray.map(year => year.index);
    
            const newIndexArray = indexArray.map(index => operator === "back" ? index - 1 : index + 1);
    
            const newyearArray = yearArray.map((year) => ({
                ...year,
                display: newIndexArray.includes(year.index),
            }));
            
            setYearArray(newyearArray);
        }
    }
    const setYearDisplay = (newyearArray, newSelectedYear) => {
        if(newyearArray.length - newSelectedYear.index > 4) {
            const indexArray = Array.from({length: 4}, (_, index) => index + newSelectedYear.index);
            newyearArray.forEach((year) => {
                year.display = indexArray.includes(year.index);
            })
        } else if(newyearArray.length - newSelectedYear.index <= 4) {
            const indexArray = Array.from({length: 4}, (_, index) => newSelectedYear.index - index);
            newyearArray.forEach((year) => {
                year.display = indexArray.includes(year.index);
            })
        }
        return newyearArray;
    }

    if(yearArray)
    return (
        <div css={s.mainContainer}>
            {displayAll 
                ? "" 
                : <div css={s.arrow(!yearArray[0].display)} onClick={() => onClickArrowHandle("back", !yearArray[0].display)}>{!yearArray[0].display ? <IoIosArrowBack /> : ""}</div>}
            {yearArray.map((year, idx) => (
                <div key={idx} css={[s.item(year.display, year.selected), displayAll && s.disPlayAllItem]} onClick={() => onClickYearHandle(year)}>{year.value}</div>
                ))}
            <div css={s.arrow(!yearArray[yearArray.length - 1].display)} onClick={() => onClickArrowHandle("forward", !yearArray[yearArray.length - 1].display)}>{!yearArray[yearArray.length - 1].display ? <IoIosArrowForward /> : ""}</div>
        </div>
    );
};

export default YearSelector;